import { formatRawAsLocal } from "core-integration/src/utils/datetime";
import { InfoText } from "plos/src/components/tooltips/InfoText";
import { useTranslation } from "react-i18next";

interface KickoffTimeCellProps {
  kickoffTime: string | null;
}

const KickoffTimeCell = ({ kickoffTime }: KickoffTimeCellProps) => {
  const { t } = useTranslation();
  return (
    <>
      {kickoffTime ? (
        <time dateTime={kickoffTime}>{formatRawAsLocal(kickoffTime)}</time>
      ) : (
        <InfoText
          label={t("kickoffTimeCell.dateTBC.label", "Date To Be Confirmed")}
        >
          {t("kickoffTimeCell.dateTBC.abbr", "TBC")}
        </InfoText>
      )}
    </>
  );
};

export default KickoffTimeCell;
